import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Features() {
  return (
    <div className="features_section p-100 case_soundly">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-lg-3">
            <h2>Features</h2>
          </Col>
          <Col xs={12} md={12} lg={3} xl={3} xxl={3}>
            <div className="features_txt">
              <p>01</p>
              <p>
                Seamless artist's profile creation option lets you create a
                personalized account of your own and access your favorite songs
                anywhere, anytime.
              </p>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={7} xl={7} xxl={7} className="offset-lg-1">
            <StaticImage
              src="../../../images/case-studies/soundly/feature_img_1.webp"
              alt="Soundly_TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={954}
              height={473}
            />
          </Col>
          <Col xs={12} md={12} lg={3} xl={3} xxl={3} className="offset-lg-1">
            <div className="features_txt center_txt">
              <p>02</p>
              <p>
                Quick and easy process of uploading songs to the application.
              </p>
            </div>
            <div className="features_txt">
              <p>03</p>
              <p>
                Quick and easy process of uploading songs to the application.
              </p>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={3} xl={3} xxl={3} className="offset-lg-7">
            <div className="features_txt">
              <p>04</p>
              <p>
                04 Equalizer through which users can choose an audio level of
                their preference.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Features;
